export default [
  {
    'text': '정상(심사통과)',
    'state': 'ACTIVE'
  },
  {
    'text': '심사중',
    'state': 'PENDING'
  },
  {
    'text': '심사 불합격',
    'state': 'REJECTED'
  },
  {
    'text': '정지',
    'state': 'SUSPENDED'
  },
  {
    'text': '탈퇴',
    'state': 'WITHDRAWAL'
  },
];



// WEBPACK FOOTER //
// ./src/api/state.js